<div class="svg-container" [innerHTML]="iconSvgStr | safeHtml"> </div> 